<template>
  <div class="mainDiv">
    <div class="secondDiv">
      <h1>欢迎！</h1>

      <p>欢迎来到DCT的IT小站，网站正在准备中，敬请期待！</p>
      <p style="margin-bottom: 10px">我的常用小工具：</p>
      <div style="margin-top: 25px">
        <ul>
          <li><a href="/tools/json/json2html/index.htm" target="_blank">JSON转换工具</a></li>
<!--          <li><a href="/tools/time/" target="_blank">时间戳转换工具</a></li>-->
          <li><a href="" @click="gotoTimeConverter">时间戳转换工具</a></li>
          <li><a href="https://website-1252117456.cos.ap-chengdu.myqcloud.com/img/CPU20200425.png" target="_blank">CPU天梯图（图片来自网络）</a></li>
          <li><a href="https://website-1252117456.cos.ap-chengdu.myqcloud.com/2019%E5%B9%B49%E6%9C%88.jpg" target="_blank">显卡天梯图（图片来自网络）</a></li>
          <li><a href="https://website-1252117456.cos.ap-chengdu.myqcloud.com/cpuz1.90/cpuz_x64.exe" target="_blank">CPUZ1.90 64位</a></li>
          <li><a href="https://website-1252117456.cos.ap-chengdu.myqcloud.com/cpuz1.90/cpuz_x32.exe" target="_blank">CPUZ1.90 32位</a></li>
          <li><a href="https://mvnrepository.com/" target="_blank">Maven库</a></li>
          <li><a href="http://tool.chinaz.com/tools/urlencode.aspx" target="_blank">Unix时间戳转换</a></li>
          <li><a href="https://xiaope.net/" target="_blank">友情链接：XiaoPE——一个纯净且功能多的WinPE</a></li>
          <p><a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备17062788号-2</a></p>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
    export default {
        name: "Home",
        methods:{
            gotoTimeConverter(){
                this.$router.push({path: '/tools/time', query: {}})
            }
        }
    }
</script>

<style scoped>
  .secondDiv {
    margin: 0 auto;
    display: block;
    text-align: left;
    width: 650px;
  }

  .mainDiv {
    text-align: center;
    padding: 150px;
  }

  li {
    color: var(--font-color);
  }

  p{
    margin-top: 20px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue